import {
  FetchSiAsigContract,
  leadsOpportunitiesListQueryKey,
  opportunitiesConvertToClientCreateMutation,
  opportunitiesListQueryKey,
  opportunitiesRetrieveQueryKey
} from '@crm/api'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { showApiErrors } from '@shared/utils'
import { useMutation } from '@tanstack/react-query'
import { App, Form, Input, Modal } from 'antd'

import { useParams } from 'react-router-dom'

import { ActionsType } from './types'

const formName = 'convert-opportunity-to-client'

export const ConvertOpportunity = ({
  opportunity,
  onCancel,
  ...props
}: ActionsType) => {
  const { t } = useLocales()
  const [form] = Form.useForm()
  const { notification } = App.useApp()
  const { invalidateQueries } = useInvalidatePredicateQueries()

  const { id: leadId } = useParams()

  const { mutate, isPending } = useMutation({
    ...opportunitiesConvertToClientCreateMutation(),
    onError: (error) => showApiErrors(error, form),
    onSuccess: (data) => {
      invalidateQueries([
        opportunitiesListQueryKey(),
        opportunitiesRetrieveQueryKey({ path: { id: Number(opportunity.id) } }),
        ...(leadId
          ? [leadsOpportunitiesListQueryKey({ path: { lead_id: leadId } })]
          : [])
      ])

      onCancel()
      notification.success({
        message: t('success.success'),
        description: data?.message
      })
    }
  })

  const onSubmit = (values: FetchSiAsigContract) => {
    if (!opportunity.id) return

    mutate({
      path: { id: Number(opportunity.id) },
      body: values
    })
  }

  return (
    <Modal
      title={t('lead.convert_to_client')}
      cancelText={t('buttons.cancel')}
      onCancel={onCancel}
      okText={t('lead.convert')}
      okButtonProps={{ htmlType: 'submit', form: formName }}
      loading={isPending}
      {...props}
    >
      <Form form={form} name={formName} onFinish={onSubmit} layout="vertical">
        <Form.Item
          name="contract_number"
          label={t('lead.contract_number')}
          rules={[{ required: true }]}
        >
          <Input placeholder={t('lead.contract_number')} />
        </Form.Item>
      </Form>
    </Modal>
  )
}
